<template>
  <div
    v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]"
    class="data-grid__multiLineTextCell"
  >
    <b-form-textarea
      v-if="options.isReactive || typeof options.isReactive === 'undefined'"
      v-model="value"
      @keydown.enter="save"
      @keydown.ctrl.83.prevent="save"
      @blur="save"
      :disabled="controlInfo.readonly"
    />
    <b-form-textarea
      v-else
      v-model="value"
      @keyup="save"
      :disabled="controlInfo.readonly"
    />
  </div>
  <div v-else class="data-grid__multiLineTextCell _multiline-text-display">
    <div class="truncated">{{ value }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'options',
    'gridId',
    'widgetKey',
    'display',
    'editMode',
    'controlInfo',
  ],
  data() {
    return {
      value: this.cellVal,
    }
  },
  watch: {
    cellVal() {
      this.value = this.cellVal
    },
  },
  computed: {
    ...mapState(['dgRowInEditMode']),
  },
  methods: {
    save() {
      if (this.controlInfo.readonly) return

      const data = {
        rowKey: this.rowKey,
        cellKey: this.cellKey,
        options: this.options,
        value: this.value,
      }

      if (this.options.isReactive || typeof this.options.isReactive === 'undefined') {
        if (this.cellVal === this.value) return

        db.dataGrid.data.saveCellVal(data)
      } else {
        const rowInst = this.$instByClass(this, 'data-grid__row')

        rowInst.rowData[this.cellKey] = this.value
      }
    },
  },
  beforeDestroy() {
    this.value = null
  },
}
</script>

<style lang="scss">
.data-grid__multiLineTextCell {
  min-width: 200px;
  textarea {
    min-height: 80px;
  }
  &._multiline-text-display {
    word-wrap: break-word;
    white-space: pre;
    .truncated {
      width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
